export default __webpack_public_path__ + "static/social-justice-3cf625ca9cc2682622f65c1a88c7e444.png";